import { render } from "./App.vue?vue&type=template&id=001ec475"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=001ec475&lang=css"

import exportComponent from "/Users/Zhuanz/Desktop/himoney/aidata/loan-management/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__